import Check from '../../../../assets/svg/Feather/Check';

export default (dispatch) => ({
  setNewCollectionTitle: (title) => {
    dispatch({
      type: 'collections/setNewCollectionTitle',
      payload: title,
    });
  },

  saveEdit: (id, newTitle) => {
    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Saving Hunt...',
        loader: true,
      },
    });

    dispatch({
      type: 'collections/updateCollectionEffect',
      payload: {
        collectionId: id,
        updates: {
          title: newTitle,
        },
      },
      callback: () => {
        dispatch({
          type: 'toast/show',
          payload: {
            text: 'Hunt saved',
            icon: Check,
            iconColor: '#f37735',
          },
        });
        dispatch({
          type: 'collections/toggleEditingCollection',
        });
        setTimeout(() => {
          dispatch({
            type: 'toast/dismiss',
          });
        }, 3500);
      },
    });
  },

  cancelEdit: () => {
    dispatch({
      type: 'collections/toggleEditingCollection',
    });
  },
});
